<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 6" fill="none">
    <path d="M1 1L6 5L11 1" stroke="black" />
  </svg>
</template>
